import React from 'react';
import { useDeliveryClient } from '../../kentico/deliveryClient';
export default function KenticoConfigFlag() {
    const [, kenticoConfig] = useDeliveryClient();
    const style = {
        position: 'absolute',
        right: 0,
        color: 'red',
        fontWeight: 'bold',
        fontSize: '30px',
    };
    const isPreviewMode = kenticoConfig.usePreviewMode;
    const isProduction = kenticoConfig?.environment?.isProduction;
    return (React.createElement("div", { style: style },
        isPreviewMode && React.createElement("h1", null, "PREVIEW MODE"),
        !isProduction && React.createElement("h1", null, "ENV OVERRIDE ACTIVE")));
}
//# sourceMappingURL=KenticoConfigFlag.js.map